import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Dashboard from '@/views/Dashboard.vue'
import Usuario from '@/views/Usuario.vue'
import novoUsuario from '@/views/novoUsuario.vue'
import Dados from '@/views/Dados.vue'
import Classes from '@/views/Classes/Classes.vue'
import novaClasse from '@/views/Classes/novaClasse.vue'
import recuperanda from '@/views/Recuperanda/recuperanda.vue'
import novaRecuperanda from '@/views/Recuperanda/novaRecuperanda.vue'
import novoProjeto from '@/views/Projeto/novoProjeto.vue'
import novoProjetoEdit from '@/views/Projeto/novoProjetoEdit.vue'
import Grafico from '@/views/Grafico.vue'
import { isUserAuthenticated } from '@/servicos/util'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  }, 
  {
    path: '/dashboard',
    name: 'dashboard',  
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuario',
    name: 'usuario',  
    component: Usuario,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuario/novo',
    name: 'usuarioNovo',  
    component: novoUsuario,
    meta: { requiresAuth: true }
  },
  {
    path: '/dados',
    name: 'dados',  
    component: Dados,
    meta: { requiresAuth: true }
  },
  {
    path: '/classes',
    name: 'classes',  
    component: Classes,
    meta: { requiresAuth: true }
  },
  {
    path: '/classes/novo',
    name: 'classesNovo',  
    component: novaClasse,
    meta: { requiresAuth: true }
  },
  {
    path: '/recuperanda',
    name: 'recuperanda',  
    component: recuperanda,
    meta: { requiresAuth: true }
  },
  {
    path: '/recuperanda/novo',
    name: 'recuperandaNovo',  
    component: novaRecuperanda,
    meta: { requiresAuth: true }
  },
  {
    path: '/projeto/novo',
    name: 'novoProjeto',  
    component: novoProjeto,
    meta: { requiresAuth: true }
  },
  {
    path: '/projeto/:id',
    name: 'novoEdit',  
    component: novoProjetoEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/grafico',
    name: 'grafico',  
    component: Grafico,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isUserAuthenticated()) {
    sessionStorage.setItem('naoConectado', "Você precisa fazer login para acessar")
    window.location.href='/'; 
  } else {
    next(); 
  }
});


export default router
